import React from 'react';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "../components/layout/Layout";
import Dashboard from "../pages/dashboard/Dashboard";
import SignIn from "../pages/auth/SignIn";

export const AppRouter = () => {
    return (
        <Router>
            <Layout>
                <Routes>
                    <>
                    <Route path="/auth/signin" element={<SignIn />}></Route>
                    <Route path="/" element={<Dashboard />}></Route>
                    <Route path={"/dashboard"} element={<Dashboard />}></Route>
                    </>
                </Routes>
            </Layout>
        </Router>
    );
}
